import React, { ReactElement } from "react";
import { ListingItem } from "@lib/shared/types";
import styles from "./listingBlock.module.scss";
import { Button } from "@components/vpnpricecomparison/button";
import DoubleArrowIcon from "@components/svg/doubleArrowIcon";
import CheckIcon from "@components/svg/checkIcon";
import CircularProgress from "./circularProgress";
import AffiliateOfferUrl from "@components/shared/affiliateOfferUrl";
import DiscountIcon from "./discountIcon";
import { AffiliateOfferZone } from "@lib/shared/config";
export default function ListingBlock({
    zone,
    index,
    item,
}: {
    zone: AffiliateOfferZone;
    index: number;
    item: ListingItem;
}): ReactElement {
    const discountValue = item.hiddenAttributes.discountValue;
    const scoreValue: string = item.hiddenAttributes.scoreValue ?? "6.3";
    const scoreMsg: string = item.hiddenAttributes.scoreMsg ?? "Super!";

    const scoreColor: string = item.hiddenAttributes?.scoreColor ?? "#83B855";
    const promoCode: string = item.hiddenAttributes?.promoCode ?? "";
    const discountColor: string =
        item.hiddenAttributes?.discountColor ?? "#83B855";

    const discount = discountValue ? (
        <div
            className={`${styles["saving"]} flex items-center justify-start md:justify-center`}
            style={{ color: discountColor }}
        >
            <DiscountIcon
                fill={discountColor}
                classes={`${styles["savingIcon"]} mr-2`}
            />
            <span>
                <span>Discount</span> <span>{discountValue}</span>
                <span>%</span>
            </span>
        </div>
    ) : (
        <div></div>
    );

    const devicesList = item.attributes.devices?.split(",").map((device) => (
        <span key={device} className={`${styles["device"]} ${styles[device]}`}>
            {device}
        </span>
    ));

    let first3Features: string[] = [];
    let restFeatures: string[] = [];
    if (Array.isArray(item.features) && item.features.length) {
        first3Features = item.features.slice(0, 3);
        restFeatures = item.features.slice(3);
    }

    const devicesListElement =
        devicesList && devicesList.length ? (
            <div className="devices flex items-center">
                <span className={styles["devicesTitle"]}>Available on:</span>
                {devicesList}
            </div>
        ) : (
            <></>
        );
    return (
        <div className={`${styles["listing-block-wrapper"]}`}>
            {index === 0 && (
                <span
                    className={`${styles["service__badge"]} ${styles["badge"]} ${styles["badge_pos"]}`}
                >
                    Best VPN of {new Date().getFullYear()}
                </span>
            )}
            <div
                className={`${styles["listing-block"]} ${
                    styles[`listing-block-${index}`]
                }`}
            >
                <div className={`${styles["inner"]}`}>
                    <div className="md:flex md:items-center md:justify-center">
                        <div className={styles["number"]}>
                            <span>{index + 1}</span>
                        </div>
                        <div className={styles["logoContentWrapper"]}>
                            {item.logo && (
                                <div className={styles["image"]}>
                                    <img
                                        className="h-7 w-auto"
                                        src={item.logo.fullPath}
                                        alt={item.description}
                                    />
                                </div>
                            )}
                            <div className={styles["content"]}>
                                {index === 0 && (
                                    <>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </>
                                )}
                                <div
                                    // style={{ color: color ?? colors.melon }}
                                    className={styles["description"]}
                                >
                                    {item.description}
                                </div>
                                <div className={styles["features"]}>
                                    <div>
                                        {first3Features.map(
                                            (feature, index) => (
                                                <div key={index}>
                                                    <CheckIcon fill="#000" />
                                                    <span>{feature}</span>
                                                </div>
                                            ),
                                        )}
                                    </div>
                                    <div className="hidden">
                                        {restFeatures.map((feature, index) => (
                                            <div key={index}>
                                                <CheckIcon fill="#000" />
                                                <span>{feature}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {devicesListElement}
                            </div>
                        </div>
                        <div
                            className={`${styles["scoreColumn"]} flex flex-row md:flex-col`}
                        >
                            <div
                                className={`${styles["score"]} flex items-center w-1/2 md:w-full`}
                            >
                                <div className={styles["scoreValue"]}>
                                    <CircularProgress
                                        scoreValue={parseFloat(scoreValue)}
                                        scoreColor={scoreColor}
                                    />
                                </div>
                                <div
                                    className={`${styles["scoreMsg"]} text-sm capitalize`}
                                >
                                    {scoreMsg}
                                </div>
                            </div>

                            {promoCode && (
                                <div
                                    className={`${styles["promoZone"]}  w-1/2 md:w-full text-xs md:text-base text-center`}
                                >
                                    <div className="text-center">
                                        For extra discount
                                    </div>
                                    <div
                                        className={`${styles["promo"]} p-1.5 mx-2  md:mx-0`}
                                    >
                                        {promoCode}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className={styles["meta"]}>
                            <div
                                className={`${styles["discountBlock"]} text-center text-xs md:text-base`}
                            >
                                {discount}
                            </div>
                            <div>
                                <Button
                                    className={`${styles["button"]} font-medium`}
                                    icon={<DoubleArrowIcon />}
                                >
                                    <AffiliateOfferUrl
                                        zone={zone}
                                        offer={item}
                                        target="_blank"
                                        className={styles["link"]}
                                    >
                                        Visit Website
                                    </AffiliateOfferUrl>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
